(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.banner = {
    attach: function (context, settings) {
      once('banner', '#banner', context).forEach(function (block) {
        let $prose = $(block).find('.prose');
        let hascol = $prose.find('.cols');
        if(hascol.length > 0) {
          //$prose.removeClass('max-w-2xl');
          $prose.addClass('max-w-none');
        }
      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
